import { Table } from '@octano/global-ui';
import { DegreeDocument } from '../types';
import { useDegreeDocumentsColumns } from './useDegreeDocumentsColumns';

type Props = {
  documents: DegreeDocument[];
  texts: {
    title: string;
    selectOptions: {
      rejected: string;
      approved: string;
      pending: string;
    };
    table: {
      noResults: string;
      headers: {
        name: string;
        documentName: string;
        load: string;
        state: string;
      };
    };
  };
};

export function DegreeDocuments({ documents, texts }: Props) {
  const columns = useDegreeDocumentsColumns(texts);
  return (
    <>
      <p className="fs-20 text-uppercase text-primary fw-700 mb-0">
        {texts.title}
      </p>
      <div className="mb-4" />
      <Table
        columns={columns}
        data={documents}
        noResultsText={texts.table.noResults}
      />
    </>
  );
}
